import { richTextToReactNode } from '@seuk/cms-api-client';
import { TableSection } from '@seuk/design-system/organisms';

import { TEXT_PAGE_SECTION_ITEM_TYPE } from '../../consts';

import LinkItem from './link-item';
import type { SectionItem as TSectionItem, TrackInfo } from './types';

export type { SectionItem } from './types';

type Props = {
  item: TSectionItem;
  trackInfo: TrackInfo;
};

export default function SectionItem({ item, trackInfo }: Props): JSX.Element {
  switch (item.type) {
    case TEXT_PAGE_SECTION_ITEM_TYPE.TEXT:
      return <>{richTextToReactNode(item.text, { useAlphabetizedList: item.useAlphabetizedList })}</>;
    case TEXT_PAGE_SECTION_ITEM_TYPE.TABLE:
      return (
        <TableSection
          title={item.title}
          headers={item.headers}
          tableRows={item.tableRows}
          columnsAlignment={item.columnsAlignment}
        />
      );
    case TEXT_PAGE_SECTION_ITEM_TYPE.LINK:
      return (
        <LinkItem
          href={item.href}
          url={item.url}
          label={item.label}
          description={item.description}
          trackInfo={trackInfo}
        />
      );
    default:
      return null;
  }
}
